import { api } from '@mbscan/client-api'
import { isSome } from '@mbscan/shared'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { HomeScreen } from '@/components/screens/home-screen'
import { toLastWorkState } from '@/features/home/last-work'
import { useActiveTenant } from '@/features/tenant/tenant-context'

function HomePage() {
  const tenant = useActiveTenant()
  const navigate = useNavigate()
  // ホームへ戻るたびに最新化したいだけなので、ポーリングはせず表示時の取得に留める。
  const { data, loading, error } = api.useFetchMetalTagScanLastActivityQuery()
  const lastWork = toLastWorkState({
    activity: data?.metalTagScanLastActivity,
    loading,
    hasError: isSome(error),
  })

  return (
    <HomeScreen
      tenant={tenant}
      lastWork={lastWork}
      onSwitchTenant={() => {
        void navigate({ to: '/' })
      }}
      onScan={() => {
        void navigate({ to: '/t/$tenant_id/millsheet/scan', params: { tenant_id: tenant.id } })
      }}
      onResults={() => {
        void navigate({ to: '/t/$tenant_id/millsheet/history', params: { tenant_id: tenant.id } })
      }}
      onLogout={() => {
        void navigate({ to: '/sign_out' })
      }}
    />
  )
}

export const Route = createFileRoute('/t/$tenant_id/')({ component: HomePage })
